import { useCapabilities } from "../../../hooks/useCapabilities";
import { useContractorNavigation } from "../../../hooks/useContractorNavigation";
import { useNavigation } from "../../../hooks/useNavigation";

export const useNotificationRedirection = () => {
  
  const {
    goToRecurringTasks,
    goToSchedulePlanning,
    goToStageGates,
    goToRiskDashboard,
    goToQueries,
    goToMeetingDetails,
    goToTaskDetails,
    goToMaterialRequestDetails,
    goToResourceRequestDetails,
    goToProjectArtefacts
  } = useNavigation();

  const { isContractorPerson } = useCapabilities();

  const { redirectContractor } = useContractorNavigation();

  const handleNotificationClick = (notification: any) => {
    if (isContractorPerson) {
      redirectContractor(notification);
      return;
    } else {
      if (
        notification.object_type === "recurring_task" &&
        notification.project_id
      ) {
        goToRecurringTasks({
          projectId: notification.project_id,
          projectName: notification.project_name,
        });
      } else if (
        (notification.object_type === "stage_gate" ||
          notification.object_type === "activity") &&
        notification.project_id
      ) {
        goToSchedulePlanning({
          projectId: notification.project_id,
          projectName: notification.project_name,
          objectId: notification.object_id,
          type:
            notification.object_type === "stage_gate"
              ? "stageGate"
              : "activity",
        });
      } else if (
        notification.object_type === "checklist" &&
        notification.project_id
      ) {
        goToStageGates({
          projectId: notification.project_id,
          projectName: notification.project_name,
          objectId: notification.object_id,
        });
      } else if (notification.object_type === "risk") {
        goToRiskDashboard({ id: String(notification.object_id) });
      } else if (notification.object_type === "queries") {
        goToQueries(notification.object_id);
      } else if (notification.object_type === "meeting") {
        goToMeetingDetails(notification.object_id);
      } else if (notification.object_type === "task") {
        goToTaskDetails(notification.object_id);
      } else if (notification.object_type === "material_request") {
        goToMaterialRequestDetails({
          projectId: notification.project_id, 
          projectName: notification.project_name, 
          requestId: notification.object_id
        });
      } else if (notification.object_type === "resource_request") {
        goToResourceRequestDetails({
          projectId: notification.project_id, 
          projectName: notification.project_name, 
          requestId: notification.object_id
        });
      } else if (notification.object_type === "artefact") {
          goToProjectArtefacts({
            projectId: notification.project_id, 
            projectName: notification.project_name, 
            artefactId: notification.object_id
          })
      }
    }
  };

  return {
    handleNotificationClick,
  };
};
